import { render, staticRenderFns } from "./BoutonAjoutIncident.vue?vue&type=template&id=396986cc&"
import script from "./BoutonAjoutIncident.vue?vue&type=script&lang=js&"
export * from "./BoutonAjoutIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396986cc')) {
      api.createRecord('396986cc', component.options)
    } else {
      api.reload('396986cc', component.options)
    }
    module.hot.accept("./BoutonAjoutIncident.vue?vue&type=template&id=396986cc&", function () {
      api.rerender('396986cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SuiviCommandes/BoutonAjoutIncident.vue"
export default component.exports